import { LinearProgress, useTheme } from '@material-ui/core';
import {
  DialogConfirm,
  DialogConfirmProps,
} from 'app/components/DialogConfirm';
import { Body, ButtonLabel } from 'app/components/Typography';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { PricingState } from '../../slice/types';

export interface CalculatePricingProps
  extends Pick<
    DialogConfirmProps,
    'isOpen' | 'onClose' | 'onConfirm' | 'onCancel' | 'title'
  > {
  edit: boolean;
  credit?: PricingState;
  creditProcessing?: boolean;
  creditCompleted?: boolean;
}
const CreditContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '16px',
  gap: 32,
  width: '100%',
  '& .creditItem': {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    width: '100%',
  },
}));
export function CalculatePricing({
  credit,
  creditProcessing,
  creditCompleted,
  edit,
  ...props
}: CalculatePricingProps) {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <DialogConfirm
      {...props}
      body={
        creditProcessing && !creditCompleted ? (
          <div style={{ width: '100%' }}>
            <LinearProgress variant="query" color="primary" />
          </div>
        ) : (
          <CreditContainer theme={theme}>
            <div className="creditItem">
              <ButtonLabel size="small">
                {t(translations.Pricing_EstimatedCost)}
              </ButtonLabel>
              <Body size="small">
                {(
                  t(
                    edit
                      ? translations.PricingConfirmationLabelEditText1
                      : translations.PricingConfirmationLabelText1,
                  ) as string
                ).replace('{0}', (credit?.credit || 0).toFixed(2))}
              </Body>
            </div>
            {!!credit?.balance && credit?.balance !== null && (
              <div className="creditItem">
                <ButtonLabel size="small">
                  {t(translations.Pricing_Balance)}
                </ButtonLabel>
                <Body size="small">
                  {(t(translations.Pricing_BalanceResult) as string).replace(
                    '{0}',
                    (credit?.balance || 0).toFixed(2),
                  )}
                </Body>
              </div>
            )}
          </CreditContainer>
        )
      }
      maxWidth={'sm'}
    />
  );
}
